import selectors from '../constants/selectors';

const matchesMedia = (element) => element?.matches?.(selectors.MEDIA_CONTAINER) || false;

export default matchesMedia;
